/**
 * Key metric display card
 */

import React from 'react'

interface MetricCardProps {
  value: string | number
  label: string
  sublabel?: string
}

export const MetricCard: React.FC<MetricCardProps> = ({
  value,
  label,
  sublabel,
}) => {
  return (
    <div className="bg-primary rounded-xl p-4 flex-1 lg:flex-initial">
      <div className="text-2xl lg:text-3xl font-bold text-accent">{value}</div>
      <div className="text-sm text-primary mt-1">{label}</div>
      {sublabel && (
        <div className="text-xs text-secondary mt-0.5">{sublabel}</div>
      )}
    </div>
  )
}

export default MetricCard
